import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'heading-3xl-desk max-md:heading-3xl mb-6'
  }
});
